import {
  ATypeCardView,
  FUNERAL_SIDO,
  FUNERAL_SIGUNGU,
  CTypeMap,
  ATypeBeneficiaryCTA,
  BTypeBreadCrumb,
  ATypeNationalMeritHead,
  FullWidthTwinButton,
  call,
  ATypeNationalMeritDescription,
  ATypeNationalMeritSummary,
  GOI_WEB_URL,
  customEvent,
  // GoiPriceDescription,
} from "goi_common";
import { GetStaticPaths, GetStaticProps } from "next";

import React from "react";
import { ParlorDetailProps } from "goi_common";
import { parlorRegion } from "@/constants/parlorRegion";
import { Box, Stack } from "@mui/material";
import Head from "next/head";
import facilities from "goi_common/src/constants/facilities_detail.json";
import { useRouter } from "next/router";

const { regionColor, targetSidos } = parlorRegion;

export const getStaticPaths: GetStaticPaths = async () => {
  const paths = facilities
    .filter((f) => targetSidos.includes(f.sido) && f.is_public)
    .map((f) => ({
      params: {
        companyname: f.companyname + " 국가유공자 안내",
      },
    }));

  return {
    paths,
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const code = params?.companyname as string;
  const companyname = code.replace(" 국가유공자 안내", "");
  let p_facility;
  let district;
  let name = "";
  let description = "";

  if (companyname) {
    p_facility = facilities.find((f) => f.companyname === companyname);
    if (p_facility) {
      name = p_facility.companyname;

      district = p_facility.address.slice(0, 2);
      if (p_facility.address.split(" ")[0].length == 4)
        district = p_facility.address[0] + p_facility.address[2];

      description = `${p_facility.companyname} 국가유공자의 장지 비용은 얼마나 들까요? 대전충청 지역의 장지의 경우, 장지마다 비용 혜택이 다르게 적용됩니다. 대전충청 지역의 국가유공자 장지 준비, 상담을 통해 도와드립니다.`;
    }
  }

  return {
    props: {
      defaultPFacility: p_facility,
      pageDescription: description,
      pageKeywords: `${p_facility?.companyname}, ${p_facility?.companyname} 국가유공자, ${district} 국가유공자 장례, ${district} 국가유공자 장지 비용, ${district} 국가유공자 공설장지, ${district} 국가유공자 장례 혜택`,
      pageOgTitle: `국가유공자를 위한 공설 장지 비용 안내 (${p_facility?.companyname})::  대전충청장례정보포털`,
      pageOgDescription: description,
      pageOgImage: p_facility?.images[0].url || "",
      hasError: !p_facility,
    },
  };
};

export default function Companyname({
  defaultPFacility,
  pageOgTitle,
}: {
  defaultPFacility: ParlorDetailProps;
  pageOgTitle: string;
}) {
  const regionPFacilities = facilities.filter((p) =>
    targetSidos.includes(String(p.sido)) && p.is_public
  );
  const sidoName = FUNERAL_SIDO.get(Number(defaultPFacility.sido));
  const sigunguName = FUNERAL_SIGUNGU.get(Number(defaultPFacility.sido))?.get(
    Number(defaultPFacility.sigungu)
  );
  const carouselItems = regionPFacilities.map((res, i) => {
    return {
      "@type": "ListItem",
      name: `(비용안내) ${res.companyname}`,
      image: `${res.images[0].url}`,
      url: `https://www.ch-funeralportal.co.kr/national-hero/free-facility/${res.companyname} 국가유공자 안내`,
      position: i + 1,
    };
  });

  const router = useRouter();

  const carouselRichSearch =
    regionPFacilities.length > 6
      ? {
          "@context": "http://schema.org",
          "@type": "ItemList",
          itemListElement: carouselItems,
        }
      : {};

  return (
    <Stack>
      <Head>
        <title>{pageOgTitle}</title>
        {regionPFacilities.length > 5 && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(carouselRichSearch),
            }}
          />
        )}
      </Head>
      <BTypeBreadCrumb
        firstItem={{
          text: `국가유공자 장례 추천`,
          href: `${GOI_WEB_URL}?utm_source=dogsound` + "/match/request/?utm_source=dogsound",
          event: {
            domain: "ch",
            path: "nat_hr_fac",
            trigger_and_target: "br_crumb_mth_req",
          },
        }}
        secondItem={{
          text: `국가유공자 장례114`,
          href: `/national-hero/`,
          event: {
            domain: "ch",
            path: "nat_hr_fac",
            trigger_and_target: "br_crumb_nat_hr",
          },
        }}
        goiHomeEvent={{
          domain: "ch",
          path: "nat_hr_fac",
          trigger_and_target: "br_crumb_goi_home",
        }}
      />

      <Box
        style={{ backgroundColor: regionColor.c100, padding: "20px 0px 0px" }}
      >
        <ATypeNationalMeritHead
          titleSido="충청 · 대전 · 세종"
          mainColor={regionColor}
          title={`국가유공자 장례114 \n${defaultPFacility.companyname} 혜택 안내`}
        />
      </Box>

      <Stack padding="24px 16px 20px" gap="12px">
        <CTypeMap
          defaultParlor={defaultPFacility}
          address={defaultPFacility.address}
        />
      </Stack>

      <Box width="100%" padding="0 20px 20px">
        <FullWidthTwinButton
          firstBtn={{
            text: "고이 상조서비스 알아보기",
            onClick: () => {
              router.push(GOI_WEB_URL + "/?utm_source=dogsound");

              customEvent({
                domain: "ch",
                path: "nat_hr_fr_facility",
                trigger_and_target: "goi_call",
              });
            },
          }}
          secondBtn={{
            text: "장례 가이드북 알아보기",
            href: GOI_WEB_URL + "/guidebook/?utm_source=dogsound",
            onClick: () => {
              customEvent({
                domain: "ch",
                path: "nat_hr_fr_facility",
                trigger_and_target: "uv_mth_req",
              });
            },
          }}
          backgroundColor={regionColor.c300}
        />

        <ATypeNationalMeritDescription />
        <ATypeNationalMeritSummary mainColor={regionColor} />
        {/* <Box className="subtitle_14_b" textAlign="center">
          고이장례연구소에서는 상담을 통해 자세한 국가 유공자 장례 혜택을
          안내드립니다.
        </Box>
        <GoiPriceDescription /> */}
      </Box>

      <Stack padding="24px 16px 10px" gap="12px">
        <h3 className="subtitle_18_b">충청 대전 세종 국가유공자 장지</h3>
        {regionPFacilities.map((res) => (
          <ATypeCardView
            key={res.companyname}
            name={res.companyname}
            href={`/national-hero/free-facility/${res.companyname} 국가유공자 안내/`}
            descriptions={["국가유공자 우선 안치"]}
            imgSrc={res.images[0]?.url ? res.images[0].url : ""}
            event={{
              domain: "ch",
              path: "nat_hr_fr_facility",
              trigger_and_target: "uv_facility",
            }}
          />
        ))}
      </Stack>
    </Stack>
  );
}
